import { render, staticRenderFns } from "./MealDelete.vue?vue&type=template&id=593e2ec9&scoped=true&"
import script from "./MealDelete.vue?vue&type=script&lang=js&"
export * from "./MealDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593e2ec9",
  null
  
)

export default component.exports